
const images = (folder, lang) => {
    let listImg = [];
    if (process.env.NODE_ENV === 'development') {
        for(let i = 1; i < 146; i++){
            listImg.push(`http://localhost:8081/media/${lang}/saphirVideo6/geoguidage_saphir_site_${i}.jpg`)
        }
    } else {
        for(let i = 1; i < 146; i++){
            listImg.push(`https://www.dioptase.fr/media/${lang}/saphirVideo6/geoguidage_saphir_site_${i}.jpg`)
        }
    }
    return listImg;
}
export default images;
